import React from 'react';
import { compose, withHandlers, lifecycle } from 'recompose';
import { Modal, ModalBody, ModalFooter } from 'reactstrap';
import Button from '../../../../../common/buttons/DeprecatedButton/DeprecatedButton';
import { END_CAMPAIGN_BODY } from './constants';
import { ENTER_KEY_NAME, ESCAPE_KEY_NAME } from '@mm/constants/keys-codes';
import './ConfirmEndModal.scss';
import { HandlerMethodTypes, LifeCycleThis } from '@mm/utils';

type OuterProps = {
  open: boolean;
  setOpen: (open: boolean) => void;
  onEndCampaign: () => void;
};

type HandlerMethods = HandlerMethodTypes<OuterProps, typeof handlers>;

type Props = HandlerMethods & OuterProps;

const onLocalEndCampaign =
  ({ setOpen, onEndCampaign }: OuterProps) =>
  () => {
    onEndCampaign();
    setOpen(false);
  };
const onKeyDown = (props: OuterProps) => (e: KeyboardEvent) => {
  if (props.open) {
    if (e.key === ENTER_KEY_NAME) {
      onLocalEndCampaign(props)();
    }
    if (e.key === ESCAPE_KEY_NAME) {
      props.setOpen(false);
    }
  }
};

const handlers = {
  onLocalEndCampaign,
  onKeyDown,
};

function componentDidMount(this: LifeCycleThis<Props>) {
  document.addEventListener('keydown', this.props.onKeyDown);
}

function componentWillUnmount(this: LifeCycleThis<Props>) {
  document.removeEventListener('keydown', this.props.onKeyDown);
}

const enhance = compose<HandlerMethods, OuterProps>(
  withHandlers(handlers),
  lifecycle<Props, {}>({ componentDidMount, componentWillUnmount }),
);

const ConfirmEndModal = (props: Props) => {
  const { onLocalEndCampaign, open, setOpen } = props;
  return (
    <Modal
      className="end-campaign-modal"
      isOpen={open}
      toggle={() => setOpen(!open)}
    >
      <ModalBody className="end-campaign-modal__body">
        <h3>{END_CAMPAIGN_BODY}</h3>
      </ModalBody>
      <ModalFooter className="end-campaign-modal__footer">
        <Button red invert onClick={onLocalEndCampaign}>
          End Campaign
        </Button>
        <Button onClick={() => setOpen(false)}>Cancel</Button>
      </ModalFooter>
    </Modal>
  );
};

export default enhance(ConfirmEndModal);
